import { userReviews } from '@/mocks/home';

const columns: typeof userReviews[] = [
  [userReviews[0], userReviews[3]],
  [userReviews[1], userReviews[4]],
  [userReviews[2], userReviews[5]],
];

export default function UserReviewsSection() {
  return (
    <section className="py-14 md:py-18 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-200 text-secondary-700 text-xs font-semibold mb-3">
            口碑评价
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 leading-tight">
            网友<span className="text-primary-500">神评</span>
            <br />
            看看大家都怎么说
          </h2>
        </div>

        {/* Masonry layout */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
          {columns.map((col, colIdx) => (
            <div key={colIdx} className="flex flex-col gap-4 md:gap-5">
              {col.map((review) => (
                <div
                  key={review.id}
                  className="bg-background-50 rounded-xl p-5"
                >
                  {/* Avatar + user info */}
                  <div className="flex items-center gap-3 mb-4">
                    <div className={`w-10 h-10 rounded-full ${review.avatarColor} flex items-center justify-center shrink-0`}>
                      <span className="text-background-50 text-sm font-bold">
                        {review.username.charAt(0)}
                      </span>
                    </div>
                    <div>
                      <div className="text-sm font-semibold text-foreground-900">{review.username}</div>
                      <div className="text-[11px] text-foreground-400">{review.handle}</div>
                    </div>
                  </div>

                  {/* Review content */}
                  <p className="text-sm text-foreground-700 leading-relaxed">
                    {review.content}
                  </p>

                  {/* Quote decoration */}
                  <div className="mt-3 text-primary-200">
                    <i className="ri-double-quotes-r text-2xl" />
                  </div>
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}